import Title from '@picsart/growth-rc/Title';
import cls from 'classnames';
import useStyles from './styles';
import { TitleWitDefaultSizeProps } from './types';

export default function TitleWithDefaultSize({ title, className }: TitleWitDefaultSizeProps) {
  const classes = useStyles();
  const autoTitleSize = title?.size === 'auto';

  return (
    <Title
      {...title}
      className={cls(classes.root, autoTitleSize && classes.titleSize, className)}
    />
  );
}
